import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectBuildingCard } from 'shared/selectors/buildingCard';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { getTechSection } from 'shared/utils/buildingDetails';
import type { IYmapsKeys, TYmapsCoordinates } from 'shared/utils/ymaps';

import { BuildingMap } from './BuildingMap';

/** Ключи — в настройках сервиса, по умолчанию значения монолита (`src/node/config.json`) */
const API_KEY_SETTING = 'CommercialBuildingCard.YandexMaps.ApiKey';
const SUGGEST_API_KEY_SETTING = 'CommercialBuildingCard.YandexMaps.SuggestApiKey';

/** Блок есть только при координатах здания */
export const BuildingMapContainer = () => {
  const card = useSelector(selectBuildingCard);
  const { coordinates } = card;
  const { config, logger } = useApplicationContext();
  const apiKey = config.get<string>(API_KEY_SETTING) ?? '';
  const suggestApiKey = config.get<string>(SUGGEST_API_KEY_SETTING) ?? '';
  const keys = useMemo<IYmapsKeys>(() => ({ apiKey, suggestApiKey }), [apiKey, suggestApiKey]);
  const latLng = useMemo<TYmapsCoordinates | null>(
    () => (coordinates ? [coordinates.lat, coordinates.lng] : null),
    [coordinates],
  );

  const handleError = useCallback(
    (error: unknown) =>
      logger.warning(error instanceof Error ? error : new Error(String(error)), {
        domain: 'components/BuildingMap',
        description: 'Ошибка загрузки Яндекс Карт',
      }),
    [logger],
  );

  return latLng ? (
    <BuildingMap coordinates={latLng} keys={keys} isAfterTech={getTechSection(card) !== null} onError={handleError} />
  ) : null;
};
